/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1ExamAnswerAnsweridAiCorrectionMutationResponse,
  PostApiV1ExamAnswerAnsweridAiCorrectionPathParams,
  PostApiV1ExamAnswerAnsweridAiCorrection400,
  PostApiV1ExamAnswerAnsweridAiCorrection401,
  PostApiV1ExamAnswerAnsweridAiCorrection404,
  PostApiV1ExamAnswerAnsweridAiCorrection500,
} from "../../types/examCorrectionDashboardController/PostApiV1ExamAnswerAnsweridAiCorrection.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1ExamAnswerAnsweridAiCorrection } from "../../clients/examCorrectionDashboardController/postApiV1ExamAnswerAnsweridAiCorrection.ts";

export const postApiV1ExamAnswerAnsweridAiCorrectionMutationKey = () =>
  [{ url: "/api/v1/exam/answer/:answerId/ai-correction" }] as const;

export type PostApiV1ExamAnswerAnsweridAiCorrectionMutationKey = ReturnType<
  typeof postApiV1ExamAnswerAnsweridAiCorrectionMutationKey
>;

export function postApiV1ExamAnswerAnsweridAiCorrectionMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = postApiV1ExamAnswerAnsweridAiCorrectionMutationKey();
  return mutationOptions<
    PostApiV1ExamAnswerAnsweridAiCorrectionMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamAnswerAnsweridAiCorrection400
      | PostApiV1ExamAnswerAnsweridAiCorrection401
      | PostApiV1ExamAnswerAnsweridAiCorrection404
      | PostApiV1ExamAnswerAnsweridAiCorrection500
    >,
    { answerId: PostApiV1ExamAnswerAnsweridAiCorrectionPathParams["answerId"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ answerId }) => {
      return postApiV1ExamAnswerAnsweridAiCorrection(answerId, config);
    },
  });
}

/**
 * @description Solicita ao modelo de IA (Gemini) a correção de uma resposta dissertativa com base nos dados da questão.
 * Suportado para questões do tipo SingleLineText e MultilineText.
 * Para questões MultilineText com subtipo configurado, a estratégia de correção varia conforme o subtipo:
 * - **OpinionArticle** (1): avalia tese, argumentação e conclusão.
 * - **Essay** (2): avalia conteúdo, completude, coesão e gramática.
 * - **ModelAnswerEssay** (3): compara à resposta-modelo e verifica os termos-chave. Requer `ModelAnswer` e `KeyTerms` cadastrados na questão.
 * - **MbaCase** (4): avalia à luz das Notas de Ensino. Requer `ModelAnswer` cadastrado na questão.
 * Retorna sugestão de nota e feedback detalhado sem salvar no banco. **(Requer Authorization para autenticação)**
 * @summary Correção de questão dissertativa por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/answer/:answerId/ai-correction}
 */
export function usePostApiV1ExamAnswerAnsweridAiCorrection<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1ExamAnswerAnsweridAiCorrectionMutationResponse,
      ResponseErrorConfig<
        | PostApiV1ExamAnswerAnsweridAiCorrection400
        | PostApiV1ExamAnswerAnsweridAiCorrection401
        | PostApiV1ExamAnswerAnsweridAiCorrection404
        | PostApiV1ExamAnswerAnsweridAiCorrection500
      >,
      {
        answerId: PostApiV1ExamAnswerAnsweridAiCorrectionPathParams["answerId"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1ExamAnswerAnsweridAiCorrectionMutationKey();

  const baseOptions = postApiV1ExamAnswerAnsweridAiCorrectionMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1ExamAnswerAnsweridAiCorrectionMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamAnswerAnsweridAiCorrection400
      | PostApiV1ExamAnswerAnsweridAiCorrection401
      | PostApiV1ExamAnswerAnsweridAiCorrection404
      | PostApiV1ExamAnswerAnsweridAiCorrection500
    >,
    { answerId: PostApiV1ExamAnswerAnsweridAiCorrectionPathParams["answerId"] },
    TContext
  >;

  return useMutation<
    PostApiV1ExamAnswerAnsweridAiCorrectionMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamAnswerAnsweridAiCorrection400
      | PostApiV1ExamAnswerAnsweridAiCorrection401
      | PostApiV1ExamAnswerAnsweridAiCorrection404
      | PostApiV1ExamAnswerAnsweridAiCorrection500
    >,
    { answerId: PostApiV1ExamAnswerAnsweridAiCorrectionPathParams["answerId"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1ExamAnswerAnsweridAiCorrectionMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamAnswerAnsweridAiCorrection400
      | PostApiV1ExamAnswerAnsweridAiCorrection401
      | PostApiV1ExamAnswerAnsweridAiCorrection404
      | PostApiV1ExamAnswerAnsweridAiCorrection500
    >,
    { answerId: PostApiV1ExamAnswerAnsweridAiCorrectionPathParams["answerId"] },
    TContext
  >;
}
